import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import Video from "./components/Video";
import ErrorBounday from './components/ErrorBoundary'
import Redirect from "./components/Redirect";
import ErrorTest from './components/ErrorTest'
import Wrapper from './components/Wrapper'
// import dotenv from 'dotenv';
// import fs from 'fs';
// dotenv.config();

function App() {

  return (
    <div>
      <BrowserRouter>
        <Provider store={store}>
          <ErrorBounday>
            <Wrapper>
              <Routes>
                  {/* <Route path="*" element={<Redirect playList={'https://devwith.jei.com/JeiApp/vodPlay.asp'} />} />  */}         
                  {/* <Route path="/test" element={<ErrorTest />} /> */}
                  <Route path="*" element={<Video />} />        
              </Routes>
            </Wrapper>
          </ErrorBounday>
        </Provider>
      </BrowserRouter>
    </div>
  );
}

export default App;
